import { useMemo } from 'react'
import { useGetSocialOrderModerationUserCandidatesQuery } from '../../../api/socialOrders'
import {
  RestrictionUserPicker,
  type RestrictionUserPickerCopy,
} from './RestrictionUserPickerView'
import type {
  RestrictionUserCandidate,
  SelectedRestrictionUser,
} from './restrictionUserUtils'

const SOCIAL_ORDER_COPY: RestrictionUserPickerCopy = {
  emptyHint:
    'Пока нет авторов комментариев — найдите пользователя по имени профиля (@...) или ссылке.',
  withSuggestionsHint: 'Введите имя профиля (@...) или выберите из авторов комментариев.',
  suggestionsTitle: 'Авторы комментариев',
  suggestionsSubtitle: 'Пользователи, оставлявшие комментарии к этому соцзаказу',
}

type Props = {
  socialOrderId: number
  selectedUser: SelectedRestrictionUser | null
  onSelectedUserChange: (user: SelectedRestrictionUser | null) => void
  submitError?: string | null
}

export function SocialOrderRestrictionUserPicker({
  socialOrderId,
  selectedUser,
  onSelectedUserChange,
  submitError = null,
}: Props) {
  const { data, isFetching } = useGetSocialOrderModerationUserCandidatesQuery(
    { socialOrderId },
    { skip: !socialOrderId },
  )

  const candidates = useMemo((): RestrictionUserCandidate[] => {
    const result: RestrictionUserCandidate[] = []
    for (const item of data?.items ?? []) {
      const id = Number(item.user_id)
      if (!Number.isSafeInteger(id) || id <= 0) continue
      result.push({
        id,
        slug: item.slug ?? null,
        fullname: item.fullname ?? null,
        shortname: item.shortname ?? null,
        avatar: item.avatar ?? null,
        restrictable: item.restrictable,
        restrictable_reason: item.restrictable_reason ?? null,
      })
    }
    return result
  }, [data?.items])

  return (
    <RestrictionUserPicker
      selectedUser={selectedUser}
      onSelectedUserChange={onSelectedUserChange}
      candidates={candidates}
      isFetching={isFetching}
      copy={SOCIAL_ORDER_COPY}
      submitError={submitError}
    />
  )
}
